import React, { Component } from 'react'
import { Field } from 'redux-form'
import Font from '@cred/react-font'
import styles from './styles.module.scss'

/**
 * @deprecated Input is deprecated, please use @cred/react-basic-form-fields/Input or @cred/react-basic-form-fields/[reduxForm|hookForm]/Input instead.
 */
class Input extends Component {
  static defaultProps = {
    component: 'input',
    autoFocus: false,
    autoFocusDelay: 500
  }

  componentDidMount() {
    const { autoFocus, autoFocusDelay } = this.props

    if (autoFocus && this.inputRef) {
      setTimeout(this.focus, autoFocusDelay)
    }
  }

  focus = () => {
    if (typeof this.inputRef.focus === 'function') {
      this.inputRef.focus()
    }
  }

  setInputRef = (ref) => {
    this.inputRef = ref

    if (this.props.ref) {
      this.props.ref(ref)
    }
  }

  render() {
    const { className, warning, warn, ...props } = this.props

    delete props.autoFocus
    delete props.autoFocusDelay

    return (
      <Font element="div" className={[className, styles.input].join(' ')}>
        <Field getInputRef={this.setInputRef} warning={warning} warn={warn} {...props} />
      </Font>
    )
  }
}

export { Input as InputNoHoc }

export default /*#__PURE__*/ Input
